import { render, staticRenderFns } from "./organTree.vue?vue&type=template&id=3a8e373d&scoped=true&"
import script from "./organTree.vue?vue&type=script&lang=js&"
export * from "./organTree.vue?vue&type=script&lang=js&"
import style0 from "./organTree.vue?vue&type=style&index=0&id=3a8e373d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8e373d",
  null
  
)

export default component.exports